import { Component, Input, OnInit } from '@angular/core';
import { Section } from 'src/app/model/shared/section';

@Component({
  selector: 'app-api-reference-introduction-section',
  templateUrl: './api-reference-introduction-section.component.html',
  styleUrls: ['./api-reference-introduction-section.component.scss']
})
export class ApiReferenceIntroductionSectionComponent implements OnInit {
  @Input() sections: Section[] = [];

  constructor() {}

  ngOnInit(): void {}
}
